import React from 'react';
import { arrayOf, bool, func, shape } from 'prop-types';
import { Drawer } from '@mui/material';

import NotificationCenter from './NotificationCenter';

const MobileNavNotifications = ({ open, setOpen, notifications }) => (
  <Drawer anchor="right" open={open}>
    <NotificationCenter notifications={notifications} setOpen={setOpen} />
  </Drawer>
);

MobileNavNotifications.propTypes = {
  notifications: arrayOf(shape({})),
  open: bool.isRequired,
  setOpen: func.isRequired,
};

MobileNavNotifications.defaultProps = {
  notifications: [],
};
export default MobileNavNotifications;
